export default {
    wait() {
    },

    done(data) {
        window.reloadModalAjax();
    },

    fail() {
        $('.cForm-Login__AjaxError').html('');
    },
};



// WEBPACK FOOTER //
// ./assets/js/component/ajax/share-athlete-edit.js